"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[258],{

/***/ 25:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SpotBuying_OrderDetails; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(5600);
// EXTERNAL MODULE: ./src/components/General/Modal.tsx
var Modal = __webpack_require__(8472);
// EXTERNAL MODULE: ./src/components/General/Input.tsx
var Input = __webpack_require__(348);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/General/RadioInput.tsx


function RadioInput(props) {
    const [isActive, setIsActive] = (0,react.useState)(false);
    const inputRef = (0,react.useRef)("");
    // FUNCTION
    const handleChange = (event)=>{
        if (props.onChange) props.onChange(event);
        setIsActive(event.target.checked);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                ref: inputRef,
                onChange: handleChange,
                defaultChecked: props.checked || false,
                className: "accent-theme-orange w-[20px] h-[20px]",
                type: "radio",
                id: props.uniqueID,
                name: props.name,
                value: props.value
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: "inline-block mx-3 cursor-pointer ".concat(props.labelProperties),
                htmlFor: props.uniqueID,
                children: [
                    " ",
                    props.label || ""
                ]
            })
        ]
    });
}
/* harmony default export */ var General_RadioInput = (RadioInput);

// EXTERNAL MODULE: ./src/components/General/TextArea.tsx
var TextArea = __webpack_require__(6965);
// EXTERNAL MODULE: ./src/components/General/Button.tsx
var Button = __webpack_require__(3607);
// EXTERNAL MODULE: ./src/store/CoreSlice.ts
var CoreSlice = __webpack_require__(1266);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(2175);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(4231);
;// CONCATENATED MODULE: ./src/validations/Order.ts

const OrderSchema = yup_es/* object */.Ry({
    buyer_company_name: yup_es/* string */.Z_().required("Buyer Name is required!"),
    phone: yup_es/* number */.Rx().required("Phone is required!").typeError("Enter a Valid Phone number"),
    email: yup_es/* string */.Z_().email().required("Email is required"),
    is_order_in_sez: yup_es/* boolean */.O7().required("Required"),
    payment_option: yup_es/* number */.Rx().required("Required").typeError(""),
    shipping_address: yup_es/* string */.Z_().required("This field is required!"),
    billing_address: yup_es/* string */.Z_().required("This field is required!")
});
/* harmony default export */ var Order = (OrderSchema);

;// CONCATENATED MODULE: ./src/components/SpotBuying/OrderDetails.tsx












function OrderDetails(param) {
    let { show , productName , onClose , data  } = param;
    const initialValues = {
        is_order_in_sez: false,
        extra_note: "",
        payment_option: 1,
        buyer_company_name: "",
        phone: data.phone || "",
        email: data.email || "",
        buyer_name: data.buyerName || "",
        shipping_address: "",
        billing_address: ""
    };
    const size = (0,useWindowSize/* default */.Z)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const { orderPayload  } = (0,es/* useSelector */.v9)((state)=>state.core);
    const { values , errors , handleSubmit , handleBlur , handleChange , touched , resetForm , setFieldValue  } = (0,formik_esm/* useFormik */.TA)({
        initialValues: initialValues,
        validationSchema: Order,
        onSubmit: (values)=>{
            const payload = {
                is_order_in_sez: values.is_order_in_sez,
                extra_note: values.extra_note,
                payment_option: values.payment_option,
                buyer_company_name: values.buyer_company_name,
                phone: data.phone || "",
                email: data.email || "",
                buyer_name: data.buyerName || "",
                purchase_price: (data.quantity * data.price).toFixed(2),
                cart_items: [
                    {
                        ...orderPayload.cart_items[0],
                        shipping_address: values.shipping_address,
                        billing_address: values.billing_address
                    }
                ]
            };
            dispatch((0,CoreSlice/* setOrderPayload */.N5)(payload));
            dispatch((0,CoreSlice/* submitOrder */.pm)());
        }
    });
    (0,react.useEffect)(()=>{
        setFieldValue("phone", data.phone);
        setFieldValue("email", data.email);
        setFieldValue("buyer_name", data.buyerName);
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        if (orderPayload.responseStatus === CoreSlice/* responseStates.SUCCESS */.Mz.SUCCESS) resetForm();
    }, [
        orderPayload.responseStatus
    ]);
    const getComponent = (data)=>{
        if (size.width < 800) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: show,
            fullScreen: true,
            children: [
                " ",
                data,
                " "
            ]
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            transition: "animateup",
            styles: "w-[50%]",
            show: show,
            children: [
                " ",
                data,
                " "
            ]
        });
    };
    const handleClose = ()=>{
        resetForm();
        onClose();
    };
    return getComponent(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "h-[80vh] lg:h-[87vh] overflow-y-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 lg:px-[30px] lg:pt-[16px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                className: "text-[#324D9F] text-[28px]",
                                children: [
                                    " ",
                                    productName,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                onClick: handleClose,
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: 1.5,
                                stroke: "currentColor",
                                className: "w-6 h-6 cursor-pointer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M6 18L18 6M6 6l12 12"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "py-4 px-4",
                        style: {
                            background: "rgba(238, 238, 238, 0.5)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid grid-cols-3 text-center",
                                style: {
                                    border: "0.2px solid rgba(0, 0, 0, 0.3)"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "border-r py-1",
                                        children: "Quantity"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "border-r py-1",
                                        children: "Price"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "py-1",
                                        children: "Total"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid grid-cols-3 text-center",
                                style: {
                                    border: "0.2px solid rgba(0, 0, 0, 0.3)",
                                    borderTop: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "border-r py-1",
                                        children: [
                                            " ",
                                            data.quantity,
                                            " KG"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "border-r py-1",
                                        children: [
                                            "$",
                                            data.price,
                                            "/Kg"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "py-1",
                                        children: [
                                            "$",
                                            (data.quantity * data.price).toFixed(2),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                children: " + taxes "
                                            }),
                                            " "
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit,
                className: "p-4 lg:px-[30px] lg:py-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-[5px] lg:flex lg:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: "inline-block mb-2 text-[15px] font-light lg:w-[40%]",
                                children: "Buyer Company Name"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:w-[58%]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    outerProperties: "border border-[#EDEDED] rounded",
                                    properties: "rounded",
                                    onChange: handleChange,
                                    value: values.buyer_company_name,
                                    name: "buyer_company_name",
                                    onBlur: handleBlur,
                                    error: errors.buyer_company_name,
                                    touched: touched.buyer_company_name
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-[5px] lg:flex lg:items-center lg:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: "inline-block mb-2 text-[15px] font-light lg:w-[40%]",
                                children: "Buyer Name"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:w-[58%]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    outerProperties: "border border-[#EDEDED] rounded",
                                    properties: "rounded",
                                    onChange: handleChange,
                                    value: values.buyer_name,
                                    name: "buyer_name",
                                    onBlur: handleBlur,
                                    error: errors.buyer_name,
                                    touched: touched.buyer_name
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-[5px] lg:flex lg:items-center lg:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: "inline-block mb-2 text-[15px] font-light lg:w-[40%]",
                                children: "Phone"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:w-[58%]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    outerProperties: "border border-[#EDEDED] rounded",
                                    properties: "rounded",
                                    onChange: handleChange,
                                    value: values.phone,
                                    name: "phone",
                                    onBlur: handleBlur,
                                    error: errors.phone,
                                    touched: touched.phone
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-[5px] lg:flex lg:items-center lg:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: "inline-block mb-2 text-[15px] font-light lg:w-[40%]",
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:w-[58%]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    outerProperties: "border border-[#EDEDED] rounded",
                                    properties: "rounded",
                                    onChange: handleChange,
                                    value: values.email,
                                    name: "email",
                                    onBlur: handleBlur,
                                    error: errors.email,
                                    touched: touched.email
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-[5px] lg:flex lg:items-center lg:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: "inline-block mb-2 text-[15px] font-light lg:w-[40%]",
                                children: "Shipping Address"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:w-[58%]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    outerProperties: "border border-[#EDEDED] rounded",
                                    properties: "rounded",
                                    onChange: handleChange,
                                    value: values.shipping_address,
                                    name: "shipping_address",
                                    onBlur: handleBlur,
                                    error: errors.shipping_address,
                                    touched: touched.shipping_address
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-[5px] lg:flex lg:items-center lg:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: "inline-block mb-2 text-[15px] font-light lg:w-[40%]",
                                children: "Billing Address"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:w-[58%]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    outerProperties: "border border-[#EDEDED] rounded",
                                    properties: "rounded",
                                    onChange: handleChange,
                                    value: values.billing_address,
                                    name: "billing_address",
                                    onBlur: handleBlur,
                                    error: errors.billing_address,
                                    touched: touched.billing_address
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-[5px] lg:flex lg:items-center lg:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: "inline-block mb-2 lg:mb-0 text-[15px] font-light lg:w-[40%]",
                                children: "Are you in SEZ? (only if shipping address is in India)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex mt-3 lg:mt-0 lg:w-[58%]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mr-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(General_RadioInput, {
                                            uniqueID: "sez__yes",
                                            name: "is_sez",
                                            label: "Yes",
                                            labelProperties: "text-[15px]",
                                            onChange: ()=>setFieldValue("is_order_in_sez", true)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(General_RadioInput, {
                                        uniqueID: "sez__no",
                                        name: "is_sez",
                                        label: "No",
                                        labelProperties: "text-[15px]",
                                        checked: true,
                                        onChange: ()=>setFieldValue("is_order_in_sez", false)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            background: "rgba(238, 238, 238, 0.5)"
                        },
                        className: "mt-[15px] px-2 py-4 rounded lg:flex lg:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: "inline-block mb-2 text-[15px] font-light lg:w-[30%]",
                                children: "Payment Option"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex mt-3 lg:mt-0 flex-wrap lg:w-[64%]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mr-3 mb-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(General_RadioInput, {
                                            uniqueID: "payment_options__LC",
                                            name: "payment_options",
                                            label: "LC",
                                            labelProperties: "text-[15px]",
                                            checked: true,
                                            value: 1,
                                            onChange: (event)=>setFieldValue("payment_option", event.target.value)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mr-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(General_RadioInput, {
                                            uniqueID: "payment_options__PDC",
                                            name: "payment_options",
                                            label: "PDC",
                                            labelProperties: "text-[15px]",
                                            value: 2,
                                            onChange: (event)=>setFieldValue("payment_option", event.target.value)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(General_RadioInput, {
                                            uniqueID: "payment_options__wireless_transfer",
                                            name: "payment_options",
                                            label: "Wire Transfer",
                                            labelProperties: "text-[15px]",
                                            value: 5,
                                            onChange: (event)=>setFieldValue("payment_option", event.target.value)
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea/* default */.Z, {
                        outerProperties: "border rounded mt-[16px]",
                        properties: "rounded",
                        onChange: handleChange,
                        value: values.extra_note,
                        name: "extra_note",
                        onBlur: handleBlur,
                        error: errors.extra_note,
                        touched: touched.extra_note
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "submit",
                        styles: "bg-theme-orange text-white mt-5 ml-auto",
                        height: 38,
                        width: 120,
                        loader: orderPayload.status === CoreSlice/* states.IN_PROGRESS */.$q.IN_PROGRESS,
                        children: "Next"
                    })
                ]
            })
        ]
    }));
}
/* harmony default export */ var SpotBuying_OrderDetails = (OrderDetails);


/***/ }),

/***/ 3226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _General_Input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(348);
/* harmony import */ var _General_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3607);
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5600);
/* harmony import */ var _General_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8472);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2175);
/* harmony import */ var _store_CoreSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1266);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9473);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7294);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4231);










function Requirements(param) {
    let { productName , data , show , onClose , onRequirementsSubmit  } = param;
    const initialValues = {
        quantity_required: null,
        required_credit_period: null,
        quantity_required_unit: 1
    };
    const requirementsSchema = yup__WEBPACK_IMPORTED_MODULE_9__/* .object */ .Ry({
        "required_credit_period": yup__WEBPACK_IMPORTED_MODULE_9__/* .number */ .Rx().nullable().required("Credit Period is required!").typeError("Please enter a day in Number!").min(1, "Credit Period must be between 1-90 days").max(90, "Credit Period must be between 1-90 days"),
        "quantity_required": yup__WEBPACK_IMPORTED_MODULE_9__/* .number */ .Rx().nullable().required("Quantity is required!").typeError("Please enter a valid Quantity!").min(data ? data.minimum_order_quantity : 1, "Quantity must be at least ".concat(data ? data.minimum_order_quantity : 1, " KG"))
    });
    const size = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();
    const { orderPayload  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)((state)=>state.core);
    const { values , errors , handleSubmit , handleBlur , handleChange , touched , resetForm  } = (0,formik__WEBPACK_IMPORTED_MODULE_5__/* .useFormik */ .TA)({
        initialValues: initialValues,
        validationSchema: requirementsSchema,
        onSubmit: (values)=>{
            const payload = {
                cart_items: [
                    {
                        fixed_price: data.id,
                        quantity_required: values.quantity_required,
                        required_credit_period: values.required_credit_period,
                        quantity_required_unit: values.quantity_required_unit
                    }
                ]
            };
            dispatch((0,_store_CoreSlice__WEBPACK_IMPORTED_MODULE_6__/* .setOrderPayload */ .N5)(payload));
            onRequirementsSubmit(productName, data.price, values.quantity_required);
            onClose();
        }
    });
    (0,react__WEBPACK_IMPORTED_MODULE_8__.useEffect)(()=>{
        if (orderPayload.responseStatus === _store_CoreSlice__WEBPACK_IMPORTED_MODULE_6__/* .responseStates.SUCCESS */ .Mz.SUCCESS) resetForm();
    }, [
        orderPayload.responseStatus
    ]);
    const getComponent = (data)=>{
        if (size.width < 800) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_General_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            show: show,
            fullScreen: true,
            children: [
                " ",
                data,
                " "
            ]
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_General_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            transition: "animateup",
            styles: "w-[50%]",
            show: show,
            children: [
                " ",
                data,
                " "
            ]
        });
    };
    const handleClose = ()=>{
        resetForm();
        onClose();
    };
    return getComponent(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "px-4 pt-2 pb-[25px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                        className: "text-[#324D9F] text-[24px] my-0 lg:text-[30px]",
                        children: [
                            " ",
                            productName,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        onClick: handleClose,
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        strokeWidth: 1.5,
                        stroke: "currentColor",
                        className: "w-6 h-6 cursor-pointer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            d: "M6 18L18 6M6 6l12 12"
                        })
                    })
                ]
            }),
            data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "border border-[0.5px] border-[#B5B5B5]",
                style: {
                    borderRadius: "0px 0px 2px 2px"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "border-b border-b-[0.5px] border-b-[#B5B5B5] flex justify-between items-center p-[10px] lg:justify-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-[15px] font-[400] lg:w-[50%]",
                                children: " Manufacturer name "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-[15px] font-[400]",
                                children: [
                                    " ",
                                    data.manufacturer_name ? data.manufacturer_name : "-",
                                    " "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "border-b border-b-[0.5px] border-b-[#B5B5B5] flex justify-between items-center p-[10px] lg:justify-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-[15px] font-[400] lg:w-[50%]",
                                children: " Pharmacopeia grades "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-[15px] font-[400]",
                                children: data.pharmacopoeia_grade_list.length > 0 ? data.pharmacopoeia_grade_list.map((grade, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        children: [
                                            grade.name,
                                            index === data.pharmacopoeia_grade_list.length - 1 ? "" : " / "
                                        ]
                                    }, index)) : "-"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "border-b border-b-[0.5px] border-b-[#B5B5B5] flex justify-between items-center p-[10px] lg:justify-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-[15px] font-[400] lg:w-[50%]",
                                children: " Quality certificates "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-[15px] font-[400]",
                                children: data.certificate_list.length > 0 ? data.certificate_list.map((certificate, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        children: [
                                            certificate.name,
                                            index === data.certificate_list.length - 1 ? "" : " / "
                                        ]
                                    }, index)) : "-"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "border-b border-b-[0.5px] border-b-[#B5B5B5] flex justify-between items-center p-[10px] lg:justify-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-[15px] font-[400] lg:w-[50%]",
                                children: " Country of manufacturing "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-[15px] font-[400]",
                                children: data.country ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            className: "w-[20px] mr-2",
                                            src: data.country.flag_link,
                                            alt: data.country.short_name,
                                            loading: "lazy"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            children: [
                                                " ",
                                                data.country.name,
                                                " "
                                            ]
                                        })
                                    ]
                                }) : "-"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "border-b border-b-[0.5px] border-b-[#B5B5B5] flex justify-between items-center p-[10px] lg:justify-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-[15px] font-[400] lg:w-[50%]",
                                children: " Stock Available "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-[15px] font-[400]",
                                children: [
                                    " ",
                                    data.quantity_available,
                                    " ",
                                    data.quantity_available_unit_details.name,
                                    " "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "border-b border-b-[0.5px] border-b-[#B5B5B5] flex justify-between items-center p-[10px] lg:justify-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-[15px] font-[400] lg:w-[50%]",
                                children: " Shipping Terms"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-[15px] font-[400]",
                                children: [
                                    " ",
                                    data.shipping_term_details ? data.shipping_term_details.name : "-",
                                    " "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-between items-center p-[10px] lg:justify-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-[15px] font-[400] lg:w-[50%]",
                                children: " Price ($) "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-[15px] font-[400]",
                                children: [
                                    " $",
                                    data.price,
                                    " ",
                                    data.price_in_rupees ? "/₹".concat(data.price_in_rupees) : "",
                                    " "
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                onSubmit: handleSubmit,
                className: "lg:flex lg:justify-between lg:items-end",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-between items-end mt-[48px] lg:mt-5 lg:w-[60%]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-[48%]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_General_Input__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    label: "Quantity Required",
                                    labelColor: "#44444",
                                    labelProperties: "text-[15px]",
                                    outerProperties: "border border-[0.5px] border-[#324D9F] h-[40px] rounded",
                                    properties: "h-[38px] rounded",
                                    placeholder: "E.g. 100 Kg",
                                    onChange: handleChange,
                                    value: values.quantity_required,
                                    name: "quantity_required",
                                    onBlur: handleBlur,
                                    error: errors.quantity_required,
                                    touched: touched.quantity_required
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-[48%]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_General_Input__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    label: "Required credit period (In Days)",
                                    labelColor: "#44444",
                                    labelProperties: "text-[15px]",
                                    outerProperties: "border border-[0.5px] border-[#324D9F] h-[40px] rounded",
                                    properties: "h-[38px] rounded",
                                    placeholder: "E.g. 30 Days",
                                    onChange: handleChange,
                                    value: values.required_credit_period,
                                    name: "required_credit_period",
                                    onBlur: handleBlur,
                                    error: errors.required_credit_period,
                                    touched: touched.required_credit_period
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[44%] lg:w-[20%]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_General_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            styles: "mt-6 bg-theme-orange text-white",
                            width: "100%",
                            height: 40,
                            children: " Next "
                        })
                    })
                ]
            })
        ]
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Requirements);


/***/ }),

/***/ 9806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _General_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8472);
/* harmony import */ var _store_CoreSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1266);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);




function SuccessModal(param) {
    let { show , image , heading , description , onClose  } = param;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    const close = ()=>{
        dispatch((0,_store_CoreSlice__WEBPACK_IMPORTED_MODULE_2__/* .closeEnquirySuccessModal */ .Mv)());
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_General_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        show: show,
        styles: "w-[80%] lg:w-1/4",
        transition: "animateup",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "content pt-4 pb-10 px-3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-end",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        onClick: onClose,
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        strokeWidth: 1.5,
                        stroke: "currentColor",
                        className: "w-6 h-6 cursor-pointer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            d: "M6 18L18 6M6 6l12 12"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-center items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: image,
                        width: 200,
                        height: 200,
                        alt: "Success",
                        className: "pt-3 pb-6"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "content text-center px-10",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "text-theme-black font-semibold",
                            children: [
                                " ",
                                heading,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "pt-2 text-theme-black font-light",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SuccessModal);


/***/ }),

/***/ 5600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

// Hook
function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: undefined,
        height: undefined
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        }
        // Add event listener
        window.addEventListener("resize", handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return ()=>window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}
/* harmony default export */ __webpack_exports__["Z"] = (useWindowSize);


/***/ })

}]);